module.exports = __webpack_public_path__ + "img/neworder.2b66b497.svg";